import { TranslatedMessage } from '@library/react-toolkit'
import { Button, PageHeader, Typography } from 'antd'
import * as React from 'react'
import QRCode from 'react-qr-code'
import styled from 'styled-components'
import { useCurrentInvoice, useRefreshInvoice } from './queries'
import { useParams } from 'react-router'

const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  & > .ant-typography {
    font-size: 1.4em;
    text-align: center;
  }
`

const DirectPayment = ({ back }: { back: () => void }) => {
  const refreshInvoice = useRefreshInvoice()
  const { invoiceID } = useParams<{ invoiceID: string }>()
  const { data: invoice } = useCurrentInvoice()
  const qrValue = `${window.location.protocol}//${window.location.host}/dcr/?v=1&op=pbl&id=${invoiceID}`

  React.useEffect(() => {
    if (invoice?.status === 'PAID') {
      window.location.href = `${window.location.href}/complete`
    }
  }, [invoice?.status])

  return (
    <div>
      <PageHeader
        title={<TranslatedMessage id="paymentByWallet" />}
        onBack={back}
      />
      <Centered>
        <QRCode value={qrValue} />
        <Typography.Paragraph>
          <TranslatedMessage id="paymentScanInstructions" />
        </Typography.Paragraph>
        <Button onClick={refreshInvoice} type="primary">
          <TranslatedMessage id="checkPayment" />
        </Button>
      </Centered>
    </div>
  )
}

export default DirectPayment
